import {
  AVS_DIRECTORY_ADDR,
  DELEGATION_MANAGER_ADDR,
  PROD_AGGREGATOR_ADDR,
  REWARDS_COORDINATOR_ADDR,
  STG_AGGREGATOR_ADDR,
} from './addresses';

export const staticArgs = [
  { name: '__avsDirectory', value: AVS_DIRECTORY_ADDR },
  { name: '__rewardsCoordinator', value: REWARDS_COORDINATOR_ADDR },
  { name: '__delegationManager', value: DELEGATION_MANAGER_ADDR },
  {
    name: 'aggregator_',
    value: window.location.href.includes('wizard.altlayer.io')
      ? PROD_AGGREGATOR_ADDR
      : STG_AGGREGATOR_ADDR,
  },
  {
    name: 'alertConfirmer_', //  For MACH. Synonymous with aggregator
    value: window.location.href.includes('wizard.altlayer.io')
      ? PROD_AGGREGATOR_ADDR
      : STG_AGGREGATOR_ADDR,
  },
];

export const deferredArgNames = ['__registryCoordinator', '__stakeRegistry', 'pauserRegistry_'];

export const ERR_MSG_COMPILE_REQUIRED = 'Your contract has not been successfully compiled.';

export const MACH_REQUIRED_FN_NAMES = [
  // 'queryOperators',
  'getRestakeableStrategies',
  'updateAVSMetadataURI',
  'createAVSRewardsSubmission',
  'owner',
  'paused',
  'transferOwnership',
  'initialize',
];

// Other BLS (excludes Mach)
export const BLS_REQUIRED_FN_NAMES = [
  'getRestakeableStrategies',
  'updateAVSMetadataURI',
  'createAVSRewardsSubmission',
  'owner',
  'paused',
  'transferOwnership',
  'initialize',
];

export const ECDSA_REQUIRED_FN_NAMES = [
  'queryOperators',
  'getRestakeableStrategies',
  'updateAVSMetadataURI',
  'createAVSRewardsSubmission',
  'owner',
  // paused,
  'transferOwnership',
  'initialize',
];

export const MACH_CONTRACT_NAME = 'MachServiceManager';
